var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.spinner)?_c('b-spinner',{attrs:{"variant":"success"}}):_c('a',{staticStyle:{"cursor":"pointer"},domProps:{"innerHTML":_vm._s(_vm.get_print_html(_vm.item.tags.has_label))},on:{"click":function($event){return _vm.print(_vm.item)}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b148e3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Expeditions_v2/Aggregates/ActionTable/Etiqueta.vue
// module id = P47/
// module chunks = 0